<template>
    <div>
        <el-dialog
            title="变更缴纳方"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="600px">
            <div class="formContent">
                <el-form ref="form" :model="form" :rules='rules'>
                    <el-form-item prop='companyInfo'>
                        <le-select-remote-search isObj notnull label="电费缴纳方" v-model="form.companyInfo" :options="optionsCompany" placeholder="请选择（可输入搜索）" />
                    </el-form-item>
                </el-form>
            </div>
            
            <div slot="footer">
                <el-button class="plainBtn" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary"  @click="submit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import util from '@/utils/util'
    export default {
        data() {
            return {
                util,
                dialogVisible: false,
                id: '',
                originCompanyName: '',
                form: {
                    companyInfo: '',
                },
                rules:{
                    companyInfo: [{required: true, message:'请选择电费缴纳方', trigger: 'change'}]
                },
                optionsCompany: {
                    url: this.$Config.apiUrl.electricMoveCompanyFilter,
                    method: "post",
                    params: {
                        projectId: ''
                    },
                    showLoading: false,
                    labelKey: "companyName",
                    valueKey: "companyId",
                    searchKey: "name",
                    pageSize: 100
                }
            };
        },
        watch:{
            dialogVisible (val) {
                if(this.$refs['form'] && !val){
                    this.$refs['form'].resetFields()
                }
            },
        },
        methods:{
            submit () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.$confirm(`“${this.originCompanyName}” 的电费项目将会复制和移交给 “${this.form.companyInfo.label}”，“${this.form.companyInfo.label}” 将可以录入电费账单，确认提交？`,'温馨提示')
                        .then(_=>{
                            this.$Axios._post({
                                url: this.$Config.apiUrl.electricChangeCompany,
                                params: { 
                                    "companyId": this.form.companyInfo.value,
                                    "projectId": this.id
                                }
                            }).then(res => {
                                this.$message.success('操作成功')
                                this.dialogVisible = false
                                this.$emit('change')
                            })
                        })
                        .catch(_=>{})
                    }
                })
            },
        }
    }
</script>
<style lang="scss" scoped>
    .content{
        background: #F2F6FC99;
        border-radius: 4px;
        padding: 10px;
        margin-bottom: 10px;
    }
    /deep/ .el-dialog__wrapper{
        display: flex;
        justify-content: center !important;
        align-items: center !important;
    }
    /deep/ .el-dialog__body{
        padding: 10px 20px !important;
    }
    /deep/ .el-dialog{
        margin: 0 auto !important;
    }
    /deep/ .is-disabled{
        color: #333333 !important;
    }
    .formContent{
        max-height: 70vh;
        overflow: auto;
    }
</style>